/**
 * The skeleton pulse (the `skeletonPulse` keyframes App injects). A row or card
 * that pulses as one sets this and gives its bars `pulse={false}`, so a long
 * list runs one animation per row rather than one per bar.
 */
export function pulse(delayMs: number): string {
  return `skeletonPulse 1.4s ease-in-out ${delayMs}ms infinite alternate`
}

/** One pulse per row, staggered 80ms down a list so it reads as a wave. */
export function pulseRow(i: number): string {
  return pulse(i * 80)
}
